export default "__VITE_ASSET__C$71q3tL__"